import React from 'react'

const Management = () => {
  return (
    <div>Management</div>
  )
}

export default Management